<script setup lang="ts">
const defaultsStore = useDefaultsStore();
const windowScroll = useWindowScroll();
</script>

<template>
    <section 
        class="w-full section-py"
        :style="{
            scrollMarginTop: windowScroll.directions.bottom
                ? '0'
                : `${ defaultsStore.headerHeight+ defaultsStore.tocHeight }px`
        }"
    >
        <slot />
    </section>
</template>